import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';

// Shared layouts
import { Dashboard as DashboardLayout } from 'layouts';

import { cleanCard } from 'js/actions/cardAction';

// Custom components
import { AllCardsTable } from './components';

// Component styles
import styles from './styles';

import { makeStyles } from '@mui/styles';
import { useLocation, useParams } from 'react-router-dom';

const useStyles = makeStyles(styles);

export default function AllCards() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { meterId } = useParams();
  const { state } = useLocation();

  useEffect(() => {
    dispatch(cleanCard());
  }, []);

  return (
    <DashboardLayout title="Tarjetas de Medición">
      <div className={classes.root}>
        <div className={classes.content}>
          <AllCardsTable props={state.id} meterId={meterId} />
        </div>
      </div>
    </DashboardLayout>
  );
}
